


// const frfr_lib_changes_id = '/FRFR/frfr-alien-editorjs-utils.js/changes_id2026-01-15r1/';


/*
FrFr FRIENDLY FRAMEWORK
frfr-alien-editorjs-utils.js
Version ID: 1a 2026-01-15r1
by 
// Please describe here if you customized this file
*/


/*
DOKUMENTACIJA:
- 

*/


export const frfr_alien_editorjs_editorjs_renderable_data_validator_quick_incomplete = (data) => {
  if (Array.isArray(data?.blocks)) {
    return true;
  }
  return false;
};

